import React from "react";
import "./login.css";
import { Input, notification } from "antd";
import moment from "moment";

export default class Login extends React.Component {
  constructor() {
    super();
    this.state = {
      date: "",
      day: "",
    };
  }

  componentDidMount() {
    let pattern = /^[A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.[A-Za-z0-9-_.+/=]*$/g;
    if (pattern.test(localStorage.getItem("token"))) 
      window.location.pathname = "/";
    var date = moment().format("MMMM Do YYYY");
    var day = moment().format("dddd");
    this.setState({ date: date, day: day });
  }

  handleSubmit = async (e) => {
    this.setState({ disabled: true });
    e.preventDefault();
    const d = this.state;
    if (!d.username || !d.password) {
      notification["error"]({
        message: "Error",
        description: "Please complete the fields below to continue.",
      });
    } else {
      this.props.signIn(this.state);
    }
  };

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.setState({ disabled: false });
    }
  }
  render() {
    const { date, day } = this.state;
    return (
      <>
        <div className="mainLogin-div">
          <div className="mainHeader-login">
            <div className="loginHead-title">
              <img
                src="https://quezoncity.gov.ph/wp-content/themes/qcproject/images/qclogo_main.png"
                alt="QCLogo"
              />
              <span>
                <b style={{ fontSize: "20px" }}>Q</b>uezon{" "}
                <b style={{ fontSize: "20px" }}>C</b>ity
              </span>
            </div>
            <div className="loginHead-date">{`${date}, ${day}`}</div>
          </div>
          <div className="loginCard-div">
            <form onSubmit={this.handleSubmit} className="loginCard-left">
              <div
                className="loginTitle"
                style={{ marginBottom: "10px", fontSize: "50px" }}
              >
                QC
              </div>
              <div
                className="loginTitle"
                style={{ marginBottom: "10px", fontWeight: "normal" }}
              >
                Zoning Administration Unit
                <br />
              </div>
              <div
                class="alert alert-warning"
                role="alert"
                style={{ width: "80%", textAlign: "center" }}
              >
                Beta Version
              </div>
              <span>
                <label className="loginInput-label" htmlFor="uname">
                  Username*
                </label>
                <Input
                  disabled={this.state.disabled}
                  id="uname"
                  placeholder="Enter your username"
                  onChange={(e) => this.setState({ username: e.target.value })}
                  className="loginInput"
                  type="email"
                  required
                  autoFocus
                />
              </span>{" "}
              <span>
                <label className="loginInput-label" htmlFor="uname">
                  Password *
                </label>
                <Input.Password
                  disabled={this.state.disabled}
                  // prefix={}
                  onChange={(e) => this.setState({ password: e.target.value })}
                  id="pwd"
                  placeholder="Enter your password"
                  className="loginInput"
                  required
                />
              </span>
              <span>
                <button
                  disabled={this.state.disabled}
                  className="btns btnLogin"
                >
                  Sign-in
                </button>
              </span>
              {/* <div className="regFoot">
                <span>Don't have yet an account?</span>{" "}
                <span onClick={() => (window.location.pathname = "/register")}>
                  Register here
                </span>
              </div> */}
              <div className="regFoot">
                <span>Need to verify your account?</span>{" "}
                <span onClick={() => (window.location.pathname = "/verify")}>
                  Click here
                </span>
              </div>
            </form>
          </div>
        </div>
      </>
    );
  }
}
